import lodash from "lodash";
import { createColumnDate, createColumnInput, createColumnSelect } from "../../../../../components/table/c-table.logic";
import i18n from "../../../../../i18n";
import store from "../../../../../store";
import { conditionFormChecker, copyForm, putField } from "../../../../../utils/form";
import { callRequestStatus, callRequestType } from "../../../storage-location/request/request.section";
import {
    createFieldSelect,
    createFieldTextArea
} from "../../../../../components/input/template-builder/template-builder.logic";
import { Modal } from "ant-design-vue";
import router from "../../../../../router";
import { createSearchOneCriteria } from "../request/request.logic";
import moment from "moment";

export const callUserObjective = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "USER_OBJECTIVE", value: searchQuery }).then(items => items.filter(item => ["1", "2"].includes(item.key)));
export const callDepartment = ({ searchQuery }) => store.dispatch("resource/v1/master/department/cacheFindAll", { searchQuery });
export const callRequestDoc = ({ searchQuery }) => store.dispatch("resource/v1/master/lookup/cacheFindAllByGroup", { group: "REQUEST_DOC", value: searchQuery });

export const callOpenInspection = ({ approveCode, informApproveCode, userInfo }) => {
    const where = [
        { name: "isActive", type: "Boolean", operator: "=", value: true },
        { name: "isTemp", type: "Boolean", operator: "=", value: false },
        { name: "refStatus.key", type: "String", operator: "=", value: "complete" },
        { name: "refDepartment.id", type: "UUID", operator: "=", value: userInfo.refDepartment?.id },
    ];
    if (informApproveCode) {
        where.push({ name: "refRelease.refInspection.refInformTemp.approveCode", type: "String", operator: "like", value: informApproveCode });
    } else if (approveCode) {
        where.push({ name: "approveCode", type: "String", operator: "like", value: approveCode });
    }
    return store
        .dispatch("resource/v1/transaction/openInspection/search", {
            criteria: {
                isDistinct: true,
                select: ["id", "approveCode", "refUserCompany.id", "refUserCompany.fullNameTh",
                    "refRelease.id",
                    "refRelease.approveCode",
                    "refRelease.refInspection.id",
                    "refRelease.refInspection.approveCode",
                    "refRelease.refInspection.refInformTemp.id",
                    "refRelease.refInspection.refInformTemp.approveCode",
                ],
                page: 0,
                size: 1000000,
                where,
                sort: [{ name: "approveCode", type: "DESC" }]
            }
        })
        .then(page => page.data);
};

export const callOpenInspectionFull = ({ props, id }) => {
    const prefix = "refOpenInspection.";
    const criteria = {
        ...createSearchOneCriteria({ props, id, prefix }),
        where: [{ name: "refOpenInspection.id", type: "UUID", operator: "=", value: id }],
    };
    return store.dispatch("resource/v1/transaction/request/search", { criteria, })
        .then(page => page.data[0])
};

export const createColumns = () => {
    const columns = [
        createColumnInput({
            title: () => i18n.global.t("model.openInspection.refUserCompany"),
            dataIndex: "refOpenInspectionTemp.refRelease.refUserCompany.companyNameTh",
            dataIndexValue: ({ record }) =>
                record.refOpenInspectionTemp?.refUserCompany?.refPersonType?.key === "1"
                    ? record.refOpenInspectionTemp?.refUserCompany?.companyNameTh
                    : record.refOpenInspectionTemp?.refUserCompany?.fullNameTh,
            customRender: ({ record, column }) => column.dataIndexValue({ record })
        }),
        createColumnInput({ title: () => i18n.global.t("model.request.draftCode"), dataIndex: "draftCode", align: "center" }),
        createColumnInput({ title: () => i18n.global.t("model.request.requestCode"), dataIndex: "requestCode", align: "center" }),
        createColumnInput({
            title: () => i18n.global.t("views.request.approveCode"),
            dataIndex: "refOpenInspection.approveCode",
            align: "center"
        }),
        createColumnInput({
            title: () => i18n.global.t("model.openInspection.invoiceCode"),
            dataIndex: "refOpenInspectionTemp.refRelease.products.refInspectionProduct.refInformProduct.invoiceCode",
            align: "center",
            customRender: ({ record }) => {
                const labels = record.refOpenInspectionTemp?.refRelease?.products?.map(d => {
                    const informProduct = d.refInspectionProduct?.refInformProduct || {};
                    return record.refOpenInspectionTemp?.refRelease?.products?.length > 1 ?
                        <div>{`(${informProduct?.invoiceSeq}) ${informProduct?.invoiceCode}`}<div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div></div>
                        : <div>{informProduct?.invoiceCode}<div>{moment(informProduct?.invoiceDate)?.format("DD/MM/YYYY")}</div></div>
                }) || [];
                return <div>{...labels}</div>
            }
        }),
        createColumnDate({
            title: () => i18n.global.t("model.openInspection.inspectionDatetime"),
            dataIndex: "refOpenInspectionTemp.inspectionDatetime",
            align: "center",
            format: "DD/MM/YYYY HH:mm"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.openInspection.refDepartment"),
            dataIndex: "refDepartment.nameTh",
            inputProp: () => ({ list: callDepartment, optLabel: "nameTh" }),
            search: { name: "refDepartment.id" },
            align: "center",
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.openInspection.refRequestDoc"),
            dataIndex: "refOpenInspectionTemp.refRelease.refInspection.refRequestDoc.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestDoc({ searchQuery }).then(d => d.filter(doc=>["02", "16", "17", "18", "19"].includes(doc?.key))),
                optLabel: "value"
            }),
            search: { name: "refOpenInspectionTemp.refRelease.refInspection.refRequestDoc.id" },
            align: "center",
        }),
        createColumnInput({
            title: () => i18n.global.t("views.request.openInspectionInfo.referDoc"),
            dataIndex: "refOpenInspectionTemp.refRelease.refInspection.refInformTemp.approveCode",
            align: "center"
        }),
        createColumnSelect({
            title: () => i18n.global.t("model.request.refStatus"),
            dataIndex: "refStatus.value",
            inputProp: () => ({
                list: ({searchQuery}) => callRequestStatus({ searchQuery }),
                optLabel: "value"
            }),
            search: { name: "refStatus.id" },
            align: "center"
        })
    ];
    return columns;
};

export const createField = ({ props, data, key }) => {
    const fields = [
        ...createFieldRequest({ props, data, key }),
    ];
    return fields;
};

export const createFieldRequest = ({ props, data, key }) => {
    const { viewOnly } = props;
    const { useForm } = data;
    const { modelRef } = useForm;
    const model = key ? lodash.get(modelRef, key) : modelRef;
    const prefix = key ? `${key}.` : "";
    return putField({
        data,
        fields: [
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refRequestType`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.request.refRequestType"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.refRequestType,
                            "onUpdate:value": value => {
                                model.refRequestType = value;
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callRequestType({ searchQuery }).then(d=>d.filter(d2 => ["2"].includes(d2?.key))),
                            optLabel: "value",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    ),
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOpenInspection.refRelease.refInspection.refInformTemp.approveCode`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.openInspectionInfo.referDoc"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refOpenInspection,
                            "onUpdate:value": value => {
                                const oldValue = model.refOpenInspection;
                                model.refOpenInspection = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneOpenInspection({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refOpenInspection = oldValue;
                                        }
                                    });
                                } else {
                                    cloneOpenInspection({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callOpenInspection({ informApproveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            optLabel: "refRelease.refInspection.refInformTemp.approveCode",
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldSelect({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}refOpenInspection`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("model.openInspection.approveCode"),
                inputProp: ({ field }) => {
                    return lodash.merge(
                        {
                            value: model.refOpenInspection,
                            "onUpdate:value": value => {
                                const oldValue = model.refOpenInspection;
                                model.refOpenInspection = value;
                                if (oldValue) {
                                    Modal.confirm({
                                        title: i18n.global.t("views.request.modal.change", {
                                            text: i18n.global.t("model.storageLocation.approveCode")
                                        }),
                                        autoFocusButton: "cancel",
                                        onOk: () => cloneOpenInspection({ props, model, id: value?.id }),
                                        onCancel: () => {
                                            model.refOpenInspection = oldValue;
                                        }
                                    });
                                } else {
                                    cloneOpenInspection({ props, model, id: value?.id });
                                }
                            },
                            disabled: viewOnly,
                            list: ({ searchQuery }) => callOpenInspection({ approveCode: searchQuery, userInfo: store.state.resource.auth.info?.user }),
                            renderLabel: ({ item }) => (
                                <div>
                                    {item.approveCode} - {item.refUserCompany?.fullNameTh}
                                </div>
                            ),
                            allowClear: false
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    );
                },
                changeLog: { getValue: ({ record, field }) => lodash.get(record, `${field.key}.value`) }
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.openInspectionInfo.remark"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.remark,
                            "onUpdate:value": value => {model.remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forRequestRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.openInspectionInfo.descToApprove"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forRequestRemark?.[0]?.remark,
                            "onUpdate:value": value => {model.lastStatus.forRequestRemark[0].remark = value},
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
            createFieldTextArea({
                visible: ({ field }) => conditionFormChecker({ props, data, executeKey: "visibleField", params: { field } }),
                key: `${prefix}lastStatus.forApproveRemark.0.remark`,
                colProp: () => ({ xs: 24 }),
                formItemProp: () => ({ labelCol: { xs: 24, md: 8 }, wrapperCol: { xs: 24, md: 16 } }),
                label: () => i18n.global.t("views.request.openInspectionInfo.descToRequest"),
                inputProp: ({ field }) =>
                    lodash.merge(
                        {
                            value: model.lastStatus.forApproveRemark?.[0]?.remark,
                            "onUpdate:value": value => (model.lastStatus.forApproveRemark[0].remark = value),
                            disabled: viewOnly
                        },
                        conditionFormChecker({ props, data, executeKey: "inputPropField", params: { field } })
                    )
            }),
        ]
    });
};

export const cloneOpenInspection = ({ props, model, id }) => {
    if (id) {
        callOpenInspectionFull({ props, id }).then(request => {
            const openInspection = request.refOpenInspection;
            const refOpenInspectionTemp = copyForm({ form: { ...openInspection, approveCode: null, isTemp: true } });
            if (id) {
                refOpenInspectionTemp?.attachments?.forEach((d, index) => (d.refRealId = openInspection.attachments[index].id));
                refOpenInspectionTemp?.products?.forEach((d, index) => {
                    d.refReal = { id: openInspection.products[index].id }
                    d.refOpenInspection = null;
                    d.productQties?.forEach((d2, index2) => {
                        d2.refReal = { ...openInspection.products[index].productQties[index2] };
                        d2.refOpenInspectionProduct = null;
                    });
                    d.samplings?.forEach((d2, index2) => {
                        d2.refReal = { ...openInspection.products[index].samplings[index2] };
                        d2.isSave = true;
                    });
                    d.sequestrates?.forEach((d2, index2) => {
                        d2.refReal = { ...openInspection.products[index].sequestrates[index2] };
                        d2.isSave = true;
                    });
                });
                refOpenInspectionTemp?.openInspections?.forEach((d, index) => {
                    d.refReal = { id: openInspection.openInspections[index].id };
                    d.isSave = true;
                });
            }
            router.push({
                name: router.currentRoute.value.name,
                params: { props: JSON.stringify({ form: { ...model, refDepartment: openInspection?.refDepartment, refOpenInspectionTemp } }) },
                query: { _timestamp: new Date().getTime() }
            });
        });
    } else {
        router.push({
            name: router.currentRoute.value.name,
            params: { props: JSON.stringify({ forceDefault: true, form: model }) },
            query: { _timestamp: new Date().getTime() }
        });
    }
};